import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

/**
 * A loading placeholder shaped like the thing it is replacing.
 *
 * Used instead of "Loading…" wherever the final layout is known, so the page
 * does not jump when data lands. Where the shape is not known — a search whose
 * result count is unknown — a plain `LoadingState` is the honest choice.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
